// extracted by mini-css-extract-plugin
export default {"sessaoFormulario":"NovoVideo_sessaoFormulario__0iyB4"};